import { ReactNode } from 'react';
import { Wrapper } from './Paragraph.styles';

// Paragraph component that supports both children and dangerouslySetInnerHTML
// but not both at the same time because that is not clear usage and will trigger a warning in React
// IMPORTANT!!! Always sanitize any HTML passed to dangerouslySetInnerHTML to prevent XSS attacks
interface CommonParagraphProps {
  'data-testid'?: string;
  className?: string;
  id?: string;
}

type ParagraphProps = CommonParagraphProps &
  (
    | {
        children?: ReactNode;
        dangerouslySetInnerHTML?: never;
      }
    | {
        children?: never;
        dangerouslySetInnerHTML: { __html: string };
      }
  );

export const Paragraph = ({
  children,
  className,
  id,
  ['data-testid']: dataTestId,
  dangerouslySetInnerHTML,
}: ParagraphProps) => (
  <Wrapper
    id={id}
    data-testid={dataTestId}
    className={className}
    dangerouslySetInnerHTML={dangerouslySetInnerHTML}
  >
    {children}
  </Wrapper>
);
